import { Preset } from './preset';
import {
  GroupEntities,
  NameValue,
  Selectable,
} from '@infodata-group/inf-commons';
import { SerializedFolderInterface } from '../../interface/serialized/serialized-folder.interface';
import { StandardMenuItem } from '../standard-menu-item';

export class Folder extends GroupEntities<Preset> implements Selectable {
  public override icon = 'folder';
  public override enable = true;

  constructor(id: string, label: string, presets: Preset[] = []) {
    super(id, label, presets);
  }

  public serialize(): SerializedFolderInterface {
    return {
      id: this.id,
      label: this.label,
      presets: this.items.map((p) => p.serialize()),
    };
  }

  public findPreset(presetId: string): Preset {
    return this.items.find((p) => p.id === presetId);
  }

  public addPreset(preset: Preset): void {
    this.items.push(preset);
    preset.folderId = this.id;
  }

  public removePreset(presetId: string): void {
    const index = this.items.findIndex((p) => p.id === presetId);
    if (index > -1) {
      this.items.splice(index, 1);
    }
  }

  public toGenericMenuItem(): StandardMenuItem {
    const item = new StandardMenuItem(this.id, this.label, '');
    item.submenus = this.items.map((p) => p.toGenericMenuItem());
    return item;
  }

  public toNameValue(): NameValue {
    return new NameValue(this.getId(), this.getLabel(), false);
  }
  public getLabel(): string {
    return this.label;
  }

  public getId(): string {
    return this.id;
  }
}
